export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $('a.tooltip-link').click(function(e){

      if ($(window).width() < 992) {
        if($(this).hasClass('tooltip-clicked')) {
          return;
        } else {
          e.preventDefault();
          $('.tooltip-link').removeClass('tooltip-clicked');
          $('.tooltip-content').removeClass('tooltip-visible');
          $(this).toggleClass('tooltip-clicked');
          $(this).find('.tooltip-content').toggleClass('tooltip-visible');
        }
      }
    });

    
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js